<script setup lang="ts">
// types
import type { BlockTextHighlightRowProps } from '@ts-blocks/block-text-highlight-row/interfaces'

defineOptions({
  name: 'BlockTextHighlightRow',
})

defineProps<{
  block: BlockTextHighlightRowProps
}>()
</script>

<template>
  <!-- span root: the row renders inline, inside headings/paragraphs of the parent block -->
  <span class="block-text-highlight-row">
    <span
      v-for="(item, index) in block.items"
      :key="item.id ?? index"
      class="block-text-highlight-row__part"
      :class="`block-text-highlight-row__part--${item.variant}`"
    >{{ item.text }}</span>
  </span>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockTextHighlightRow.scss" />
